var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 8.25V2.625H8.25V8.25H2.625ZM2.625 15.375V9.75H8.25V15.375H2.625ZM9.75 8.25V2.625H15.375V8.25H9.75ZM9.75 15.375V9.75H15.375V15.375H9.75ZM3.75 7.125H7.125V3.75H3.75V7.125ZM10.875 7.125H14.25V3.75H10.875V7.125ZM10.875 14.25H14.25V10.875H10.875V14.25ZM3.75 14.25H7.125V10.875H3.75V14.25Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.03162f497fb8f38a4f7704f4f20db5db.svg";
export { ForwardRef as ReactComponent };